import { Component, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { MonitoringLeftSidebarService } from '../../services/monitoring-left-sidebar.service';
import { MentionsApi } from '../../../../api/mentions/mentions.api';
import { MonitoringRoutingService } from '../../services/monitoring-routing.service';
import { AlertsService } from '../../../Alerts/services/alerts.service';
import { TopicsService } from '../../services/topics.service';
import { MentionSearchService } from '../../services/mention-search.service';
import { AbstractHypeService } from '../../../../Common/Layout/services/abstract-hype.service';
import { MonitoringHypeService } from '../../services/monitoring-hype.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { LeftSidebarService } from '../../../../Common/Layout/services/left-sidebar.service';
import { CsvImportDialogService } from '../../../../Common/Dialogs/components/CsvImportDialog/csv-import-dialog.service';
import { MentionCsvImportDialogService } from '../../../Shared/services/mention-csv-import-dialog.service';
import { LeftSidebarManagementService } from '../../../../Common/Layout/services/left-sidebar-management.service';
import { MonitoringLeftSidebarManagementService } from '../../services/monitoring-left-sidebar-management.service';


@Component({
    selector: 'agpr-monitoring',
    templateUrl: './monitoring.component.html',
    styleUrls: ['./monitoring.component.scss'],
    providers: [
        {
            provide: LeftSidebarService,
            useExisting: MonitoringLeftSidebarService
        },
        {
            provide: AbstractHypeService,
            useClass: MonitoringHypeService
        },
        {
            provide: FilterService,
            useExisting: MentionSearchService
        },
        {
            provide: CsvImportDialogService,
            useClass: MentionCsvImportDialogService
        },
        MentionCsvImportDialogService,
        {
            provide: LeftSidebarManagementService,
            useExisting: MonitoringLeftSidebarManagementService
        },
    ],
    standalone: false
})
export class MonitoringComponent implements OnDestroy {

    private subscriptions: Subscription[] = [];

    constructor(
        public sidebarService: MonitoringLeftSidebarService,
        public mentionsApi: MentionsApi,
        private topicsService: TopicsService,
        private monitoringRoutingService: MonitoringRoutingService,
        private alertsService: AlertsService,
    ) {
        this.subscriptions.push(
            this.sidebarService.getShowNewAlertDialogProvider().subscribe(
                showNewAlert => {
                    if (showNewAlert) {
                        this.showAlertAmplify();
                    }
                }
            ),
            this.sidebarService.getShowNewTopicDialogProvider().subscribe(
                showNewTopic => {
                    if (showNewTopic) {
                        this.showTopicAmplify();
                    }
                }
            ),
        );
    }


    /**
     * Opens the topic amplify dialog, provided the user can leave the current topic
     */
    private showTopicAmplify() {
        this.topicsService.showExitDialog().subscribe(
            result => {
                if (result) {
                    this.topicsService.resetTopicToCache();
                    this.monitoringRoutingService.gotoSearch();
                }
            }
        );
    }

    /**
     * Opens the alert amplify dialog, provided the user can leave the current alert
     */
    private showAlertAmplify() {
        this.alertsService.showCanLeaveDialog().subscribe(
            result => {
                if (result) {
                    this.alertsService.openNewAlertDialog();
                }
            }
        );
    }


    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
